/*
 * @Author: Ashley.Liu
 * @Date: 2022-02-23 14:48:40
 * @LastEditTime: 2022-04-15 13:31:45
 * @Description: multi tab options
 */
import Vue from 'vue'
import router, { routerConfig } from '@/plugins/router'
import store from '@/store'
import cloneDeep from 'lodash/cloneDeep'
const MAX_CACHE_QUEUE_NUMBER = 5

function searchRouteByName (name) {
  let routerItem
  function search (configs) {
    if (!configs?.length) return

    configs.forEach(item => {
      if (item.name === name) {
        routerItem = item
      }
      search(item.children)
    })
  }
  search(routerConfig.routes)
  return routerItem
}

function pushTabs ({ name, query, params, label }) {
  const routerItem = searchRouteByName(name)
  let tab
  if (this.list.find(e => e.label === label)) {
    tab = this.list.find(e => e.label === label)
    tab.query = query
    tab.params = params
    // localstorage can not store component constructor
  } else {
    // add a new
    tab = {
      ...routerItem,
      label,
      query,
      params,
      uuid: parseInt(this.list[this.list.length - 1]?.uuid || 0) + 1 + ''
      // uuid: label
    }

    if (this.list.length < MAX_CACHE_QUEUE_NUMBER) {
      this.list.push(tab)
    } else {
      this.list.shift()
      this.list.push(tab)
    }
  }

  store.commit('multiTabs/setList', this.list)

  if (!this.current) {
    this.cacheRouter = {
      name: router.history.current.name
    }
    store.commit('multiTabs/setCacheRouter', this.cacheRouter)
  }
  this.current = tab
  store.commit('multiTabs/setCurrent', this.current)
}

function removeTab (index) {
  this.list.splice(index, 1)
  store.commit('multiTabs/setList', this.list)
  if (this.list.length) {
    const newIndex = index !== 0 ? index - 1 : 0
    this.current = this.list[newIndex]
    store.commit('multiTabs/setCurrent', this.current)
    router.push(this.current)
  } else {
    this.current = null
    store.commit('multiTabs/setCurrent', this.current)
    router.push(this.cacheRouter)
  }
}

function clear () {
  this.list = []
  this.current = null
  store.commit('multiTabs/setList', this.list)
  store.commit('multiTabs/setCurrent', this.current)
}

/**
 * component can not cache to localStorage
 * need reasign
 * @returns multi tabs
 */
function getList () {
  let list = cloneDeep(store.state.multiTabs.list)
  list = list.map(t => {
    const routerItem = searchRouteByName(t.name)
    if (routerItem && routerItem.component) {
      return {
        component: routerItem.component,
        ...t
      }
    } else {
      return null
    }
  }).filter(x => x !== null)
  return list
}

Vue.prototype.$MultiTabs = {
  list: getList(),
  current: cloneDeep(store.state.multiTabs.current),
  cacheRouter: cloneDeep(store.state.multiTabs.cacheRouter),
  push: pushTabs,
  remove: removeTab,
  clear
}
